// extracted by mini-css-extract-plugin
export default {"messageContainer":"N_dCW","icon":"Fx1Nq","text":"kPJLo"};